import Repository from "@/repositories/Repository";

const resource = "/mass_reduces";
export default {
  store(payload) {
    return Repository.post(`${resource}`, payload);
  },
  show(id) {
    return Repository.get(`${resource}/${id}`);
  },
};
